import React from 'react'
import { TicketList } from 'src/pages/worldCup2026/tickets/list'

export const WorldCup2026TicketsPage = () => {
  return <TicketList />
}
